// ─── ConfirmModal.js ──────────────────────────────────────────────────────────
// Styled confirmation dialog to replace browser window.confirm().

import React from 'react';

export default function ConfirmModal({ title, message, confirmLabel, cancelLabel, danger, onConfirm, onCancel, emailAction }) {
  return (
    <div className="cm-overlay" onClick={onCancel} role="presentation">
      <div className="cm-dialog" role="dialog" aria-modal="true" aria-labelledby="cm-title" onClick={e => e.stopPropagation()}>
        {title && <div className="cm-title" id="cm-title">{title}</div>}
        {message && <div className="cm-message" style={{whiteSpace:'pre-line'}}>{message}</div>}
        <div className="cm-buttons">
          <button className="cm-btn cm-cancel" onClick={onCancel}>{cancelLabel || 'Cancel'}</button>
          {emailAction && (
            <a className="cm-btn cm-confirm" style={{background:'#059669',textDecoration:'none',textAlign:'center'}}
              href={`mailto:?subject=${encodeURIComponent(emailAction.subject)}&body=${encodeURIComponent(emailAction.body)}`}>
              ✉️ Email
            </a>
          )}
          <button className={`cm-btn cm-confirm ${danger ? 'cm-danger' : ''}`} onClick={onConfirm}>{confirmLabel || 'OK'}</button>
        </div>
      </div>
    </div>
  );
}
